import styled from 'styled-components'
import { Flex } from 'ui/acro'

const TitleContainer = styled(Flex)`
    justify-content: space-between;
    align-items: center;
)`
export default TitleContainer
